import * as Common from '@/assets/js/common.js'
// import { mapState } from 'vuex'

function setPageTitle(title) {
  document.title = title
}

export default {
  props: ['params'],
  data: function () {
    return {}
  },
  beforeCreate: function () {
  },
  created: function () {
    this.Common = Common
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  activated: function () {
    var me = this
    if (this.$options.pageName) {
      setPageTitle(this.$options.pageName)
    }
  },
  deactivated: function () {
  },
  beforeDestroy: function () {
  },
  destroyed: function () { },

  methods: {
    setPageTitle: setPageTitle
  }
}
